import { createRef, Component } from "react";
import { graphql } from "gatsby";
import { AppendToDomHelper } from "components/helpers/index";
import { EventAggregator, extract, isArray } from "@parksandresorts/core";
import styles from "./iframe-caspeco-block.module.less";

export default class IframeCaspecoBlock extends Component {
  constructor(props) {
    super(props);
    this.contentful_id = extract(props, "contentful_id");
    this.iframeOrCaspeco = extract(props, "iframeOrCaspeco");
    this.iframeUrl = extract(props, "iframeUrl");
    this.caspecoUnitId = extract(props, "caspecoUnitId");
    const caspecoSectionIdsArr = extract(props, "caspecoSectionIds");
    this.caspecoDataAdvanced = extract(props, "caspecoDataAdvanced", false);
    this.caspecoDataHeight = extract(props, "caspecoDataHeight", null);
    this.caspecoOnlineOrder = extract(props, "caspecoOnlineOrder", null);
    this.caspecoSectionIds = isArray(caspecoSectionIdsArr) ? caspecoSectionIdsArr.join(",") : "";
    this.language = props.node_locale === "sv" ? "sv-SE" : "en-US";
    this.title = extract(props, "title", null);

    this.ref_caspeco = createRef();
    this.scriptTagId = `caspeco_script_${this.contentful_id}`;

    this.state = {
      isCaspecoLoaded: false,
      isIframeLoaded: false,
    };
  }

  componentDidMount() {
    if (this.iframeOrCaspeco) {
      // Load iframe
    } else {
      // Caspeco true
      window.CaspecoSDKObject = "ca";
      AppendToDomHelper.loadScriptTag(
        this.ref_caspeco,
        "https://cdn.caspeco.se/sv_SE/sdk.js?version=c1.0.0",
        this.scriptTagId,
      )
        .then(() => {
          console.log("Caspeco script loaded");
          setTimeout(() => {
            // Add timeout to make sure the Caspeco js has been parsed by the browser
            window.ca.addEventListener("bookingEvent", this.onCaspecoBookingEvent.bind(this));
          }, 25);
        })
        .catch((err) => {
          EventAggregator.publish("trackException", {
            customMessage: "Caspeco script error: ",
            exception: err,
          });
        });
    }
  }

  componentWillUnmount() {
    // Cleanup
    if (!this.iframeOrCaspeco && this.caspecoUnitId && this.scriptTagId) {
      const scriptTag = document.getElementById(this.scriptTagId);
      if (scriptTag) {
        scriptTag.remove();
      }
      delete window["ca"];
    }
  }

  onCaspecoBookingEvent(event, payload) {
    if (payload.eventType === 3) {
      // 'FinalizeWebBooking'
      // trigger event
      EventAggregator.publish("trackEvent", {
        category: "Restaurant Booking",
        action: "FinalizeWebBooking",
        label: this.caspecoUnitId,
        value: payload.guestCount ?? 0,
      });
    }
  }

  renderIframe() {
    return undefined;
  }

  renderCaspeco() {
    return (
      <div id="caspeco" ref={this.ref_caspeco}>
        <div
          className="caspeco-booking"
          data-system="se_grosto"
          data-unitid={this.caspecoUnitId}
          data-sectionids={this.caspecoSectionIds}
          data-lang={this.language}
          data-advanced={this.caspecoDataAdvanced}
          data-onlineorder={this.caspecoOnlineOrder}
          data-height={this.caspecoDataHeight ? this.caspecoDataHeight : null}
        ></div>
      </div>
    );
  }

  render() {
    return (
      <section className="block" data-contentful-id={this.props.contentful_id}>
        <div className="block--max-width-narrow block--padded">
          {this.title && <h2 className={styles.title}>{this.title}</h2>}
          {this.iframeOrCaspeco ? this.renderIframe() : this.renderCaspeco()}
        </div>
      </section>
    );
  }
}

export const fragmentFactBlock = graphql`
  fragment IframeCaspecoBlock on ContentfulIframeCaspecoBlock {
    contentful_id
    id
    node_locale
    title
    iframeOrCaspeco
    iframeUrl
    caspecoUnitId
    caspecoSectionIds
    caspecoDataAdvanced
    caspecoDataHeight
    caspecoOnlineOrder
  }
`;
